import { createSelector } from 'reselect';
import { isEmptyObject } from '@travel/utils';

import type { SearchEngineState } from './reducer';
import type { RootState } from 'typesafe-actions';

export const getSearchEngineState = (state: RootState) => state.searchEngine;
export const getSearchEngine = createSelector(getSearchEngineState, (state: SearchEngineState) =>
  isEmptyObject(state.searchEngineType) ? undefined : state.searchEngineType,
);
